module.exports = __webpack_public_path__ + "img/finish.270de998.svg";